<template>
  <div class="vue-modal-dialog-mask" :class="$style.modal">
    <div class="vue-modal-dialog-content">
      <header>
        Add to Playlist
        <button
          type="button"
          @click="$close(true)"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
        >
          <font-awesome-icon :icon="faTimes" />
        </button>
      </header>
      <div>
        <div :class="$style.formGroup">
          <input
            v-model="name"
            name="name"
            placeholder="Name"
            class="playlistField"
            :class="$style.name"
            v-validate="`required|max:${maxNameLength}`"
            :maxlength="maxNameLength"
          />
          <span :class="$style.error" v-show="errors.has('name')">{{
            errors.first("name")
          }}</span>
        </div>
        <div :class="$style.formGroup">
          <multiselect
            v-model="selectedPlaylists"
            label="name"
            track-by="id"
            placeholder="Playlist"
            open-direction="bottom"
            :allow-empty="true"
            :show-labels="false"
            :options="playlists"
            :multiple="true"
          >
            <template #noResult>
              <span>No matches found</span>
            </template>
          </multiselect>
          <span :class="$style.error" v-show="errors.has('playlists')">{{
            errors.first("playlists")
          }}</span>
        </div>
      </div>
      <footer>
        <button :class="$style.add" :disabled="busy" @click="addToPlaylist">
          Add to Playlist
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-components/vue-multiselect";
import { createNamespacedHelpers } from "vuex";
import { successNotification, errorNotification } from "../../notifications";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";

const { mapState, mapActions } = createNamespacedHelpers("activitySummary");

export default {
  components: {
    Multiselect,
    FontAwesomeIcon,
  },
  data() {
    return {
      faTimes,
      selectedPlaylists: [],
      busy: false,
      playlists: [],
      timeStart: 0,
      timeEnd: null,
      name: "",
      maxNameLength: 100,
    };
  },
  computed: {
    ...mapState(["activity"]),
    showPlaylistsUrl() {
      return `${this.$_activitySummary_config.jiminnyHost()}/api/v1/playlists/user`;
    },
    addToPlaylistUrl() {
      return `${this.$_activitySummary_config.jiminnyHost()}/api/v1/activity/${
        this.activity.id
      }/playlists`;
    },
    hostClass() {
      return `host-${this.$_activitySummary_config.hostApp}`;
    },
    selectedIds() {
      return this.selectedPlaylists.map((playlist) => playlist.id);
    },
    trackTitle() {
      let trackTitle = "";
      if (this.activity.prospect) {
        const { type, name, account, company } = this.activity.prospect;
        switch (type) {
          case "account":
            trackTitle = name;
            break;
          case "lead":
            trackTitle = company;
            break;
          case "contact":
            trackTitle = account ? account.name : name;
        }
      } else if (this.activity && this.activity.title) {
        trackTitle = this.activity.title;
      }

      return trackTitle;
    },
  },
  watch: {
    selectedPlaylists() {
      this.errors.remove("playlists");
    },
  },
  created() {
    this.name = this.trackTitle;
    this.loadPlaylists();
  },
  methods: {
    ...mapActions(["favoriteActivity"]),
    loadPlaylists() {
      return axios
        .get(this.showPlaylistsUrl)
        .then((response) => {
          this.playlists = response.data.map((playlist) => ({
            id: `${playlist.id}`,
            name: playlist.name,
            isFavorited: playlist.isFavorited,
          }));
        })
        .catch(console.error);
    },
    addToPlaylist() {
      let isValid = true;
      this.$validator.validateAll().then((result) => {
        if (this.selectedPlaylists.length === 0) {
          isValid = false;
          this.errors.add("playlists", "The playlist field is required.");
        }

        if (!result || !isValid) {
          return;
        }

        const payload = {
          playlists: this.selectedIds,
          start_time: this.timeStart,
          end_time: this.timeEnd,
          name: this.name,
        };

        this.busy = true;
        const selectedPlaylistsTexts = this.selectedPlaylists.map(
          (playlist) => playlist.name
        );
        const isFavorited = this.selectedPlaylists.filter((playlist) => {
          return playlist.isFavorited === true;
        });

        return axios
          .post(this.addToPlaylistUrl, payload)
          .then((response) => {
            if (isFavorited.length > 0) {
              this.favoriteActivity();
            }
            this.closeModal();

            const selectedPlaylistNames = selectedPlaylistsTexts.join(", ");
            successNotification({
              message: `Added to ${selectedPlaylistNames}`,
            }).show();
          })
          .catch((error) => {
            this.handleErrors(error.response);
            this.busy = false;
          });
      });
    },
    closeModal() {
      this.$close(true);
    },
    handleErrors(response) {
      const errors = response.data;

      if (response.status === 403) {
        errorNotification({
          message: "You are not authorized to perform this action",
        }).show();
        this.closeModal();
      } else if (errors.hasOwnProperty("errors")) {
        Object.keys(errors.errors).forEach((key) => {
          this.errors.add(key, errors.errors[key][0]);
        });
      } else {
        errorNotification({
          message: "Something went wrong. Please try again later.",
        }).show();
        this.closeModal();
      }
    },
  },
};
</script>

<style module lang="less" src="./add-to-playlist-modal.less"></style>



// WEBPACK FOOTER //
// add-to-playlist-modal.vue?774485c1